import { NON_SAMPLE_LIST_TYPES } from 'lib_ts/enums/pitches.enums';
import { IBallTypeConfig } from 'lib_ts/interfaces/i-ball-types';
import { IPitchList } from 'lib_ts/interfaces/pitches';
import { AdminBallTypesService } from 'services/admin/ball-types.service';
import { PitchListsService } from 'services/pitch-lists.service';
import { create } from 'zustand';

interface BallTypesState {
  loading: boolean;
  configs: IBallTypeConfig[];
  refLists: IPitchList[];
}

interface BallTypesActions {
  updateConfig: (id: string, value: Partial<IBallTypeConfig>) => void;

  fetchConfigs: () => void;
  fetchRefLists: () => void;
}

type BallTypesStore = BallTypesState & BallTypesActions;

const initialState: BallTypesState = {
  loading: false,
  refLists: [],
  configs: [],
};

const useBallTypesStore = create<BallTypesStore>((set, _get) => ({
  ...initialState,

  // actions

  updateConfig: async (id, value) => {
    set({ loading: true });

    const result = await AdminBallTypesService.getInstance().update({
      ...value,
      _id: id,
    });

    set((prev) => ({
      loading: false,
      configs: prev.configs.map((c) => (c._id === id ? (result ?? c) : c)),
    }));
  },

  fetchConfigs: async () => {
    set({ loading: true });

    const results = await AdminBallTypesService.getInstance().getAll();

    set({
      loading: false,
      configs: results,
    });
  },

  fetchRefLists: async () => {
    set({ loading: true });

    const results = await PitchListsService.getInstance().getLiveReferences();

    set({
      loading: false,
      refLists: results.filter(
        (m) =>
          m.reference_type && NON_SAMPLE_LIST_TYPES.includes(m.reference_type)
      ),
    });
  },
}));

export default useBallTypesStore;
